import { ReactElement } from 'react';
import { Field, ErrorMessage } from 'formik';
import classNames from 'classnames';

interface TextAreaFieldProps {
  name: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
  labeled?: boolean;
  className?: string;
  rows?: number;
  maxLength?: number;
}

const TextAreaField = ({
  name,
  label,
  placeholder,
  required = false,
  labeled = false,
  className = '',
  rows = 3,
  maxLength,
}: TextAreaFieldProps): ReactElement => {
  return (
    <div className={classNames('flex flex-col w-full mb-4', className)}>
      {labeled && label && (
        <label htmlFor={name} className="mb-2 text-sm font-medium">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <Field name={name}>
        {({ field, meta }: any) => (
          <textarea
            {...field}
            id={name}
            placeholder={placeholder}
            rows={rows}
            maxLength={maxLength}
            className={classNames(
              'w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-copper focus:border-transparent resize-vertical',
              {
                'border-red-500': meta.touched && meta.error,
                'border-gray-300': !meta.touched || !meta.error,
              }
            )}
            required={required}
          />
        )}
      </Field>
      <ErrorMessage
        name={name}
        component="div"
        className="text-red-500 text-xs mt-1"
      />
    </div>
  );
};

export default TextAreaField;